module.exports = __webpack_public_path__ + "static/music-player-image-mob-b481ea8028ad263b6c93150db5223d4d.png";